export default "__VITE_ASSET__hv88ftTX__"